import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { APPEARANCE } from './constants';

const FieldStatus = ({ appearance = APPEARANCE.default, text = '', ...otherProps }) => {
  const classes = classNames('ws-ui-field-status', `ws-ui-field-status--${appearance}`);

  return (
    <p className={classes} {...otherProps}>
      {text}
    </p>
  );
};

FieldStatus.propTypes = {
  appearance: PropTypes.oneOf(Object.values(APPEARANCE)),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default FieldStatus;
